export default "**Payment received**\n\n{fullPayment} paid on {fullPaymentDate}\n";